// Module
var code = "<vt-header></vt-header>\n<div vt-sidebar ng-if=\"auth.isFullyLoggedIn()\"></div>\n<div vt-submenu ng-if=\"auth.isFullyLoggedIn()\"></div>\n";
// Exports
var _module_exports = code;;
var path = 'template/component/main-menu.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;